import { FunctionComponent } from 'react';
import { PlaygroundFile } from '@playground/models/files.model';
import classNames from 'classnames';

interface Props {
  visibleFiles: PlaygroundFile[];
  activeFile: string;
  setActiveFile: (filePath: string) => void;
}

const FilesTabs: FunctionComponent<Props> = ({ visibleFiles, activeFile, setActiveFile }) => {
  return (
    <div
      className="flex w-full space-x-2 border-b border-zinc-400 ml-2"
      aria-label="Select active file"
      role="tablist"
    >
      {visibleFiles.map((file) => (
        <button
          key={file.path}
          aria-selected={file.path === activeFile}
          className={classNames('px-2 py-2 text-xs font-mono font-thin', {
            'text-slate-600': file.path !== activeFile,
          })}
          onClick={() => setActiveFile(file.path)}
          role="tab"
          title={file.path}
          type="button"
        >
          {file.path}
        </button>
      ))}
    </div>
  );
};

export default FilesTabs;
